import { render, staticRenderFns } from "./new_orders_widget.vue?vue&type=template&id=0cf4a9ca&scoped=true&"
import script from "./new_orders_widget.vue?vue&type=script&lang=js&"
export * from "./new_orders_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4a9ca",
  null
  
)

export default component.exports